import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UtilityService } from '../../core/services/utility/utility.service';
import { NgIf } from '@angular/common';
import { NoiseCatalogLeftNavigationPaneComponent } from './noise-catalog-left-navigation-pane/noise-catalog-left-navigation-pane.component';
import { RouterOutlet } from '@angular/router';
export interface IMedia {
  title: string;
  src: string;
  type: string;
}

@Component({
    selector: 'app-noise-catalog',
    templateUrl: './noise-catalog.component.html',
    styleUrls: ['./noise-catalog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NoiseCatalogLeftNavigationPaneComponent,
        RouterOutlet,
    ],
})
export class NoiseCatalogComponent implements OnInit {

  public screenWidth: number;
  
  constructor(private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}
